import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { DocumentTypeReferenceModel } from "../../models/reference-model/reference-general-model/document-type-reference.model";

@Injectable({
    providedIn: 'root'
})
export class DocumentTypeReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/DocumentTypeReferences';

    constructor(
        httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getDocumentTypeReferences(): Observable<DocumentTypeReferenceModel[]> {
        return this.httpGet<DocumentTypeReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}